import { Link } from "react-router-dom";
import { WashingMachine, Wind, Sparkles, MapPin, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MachineCard, ClientCardBanner, VendingBlock } from "@/components/home/PriceCards";

const MACHINES = [
  { icon: WashingMachine, name: "Lavadoras 1 y 2", capacity: "12 KG", cash: "5,00 €", card: "4,00 €" },
  { icon: WashingMachine, name: "Lavadora 3", capacity: "20 KG", cash: "9,00 €", card: "7,50 €" },
  { icon: Wind, name: "Secadoras 4 y 5", capacity: "19 KG", cash: "3,00 €", card: "2,50 €" },
];

export const InStorePrices = () => (
  <section id="precios-tienda" className="pt-28 sm:pt-36 pb-16 sm:pb-24 bg-slate-900 text-white" data-testid="instore-prices-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="max-w-3xl mb-10 sm:mb-14 fade-up">
        <span className="inline-flex items-center gap-2 bg-cyan-500/15 text-cyan-300 text-xs sm:text-sm font-medium px-3 sm:px-4 py-1.5 rounded-full mb-5 sm:mb-6">
          <Sparkles className="h-4 w-4 shrink-0" /> Autoservicio en el Actur · Todos los días 7:30 – 22:30
        </span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-extrabold tracking-tight leading-tight">
          Precios en Tienda <span className="text-cyan-400">(Autoservicio)</span>
        </h1>
        <p className="mt-4 sm:mt-5 text-base md:text-lg text-slate-300 max-w-2xl">
          Ven a nuestro local y usa nuestras máquinas cuando quieras. Paga en efectivo,
          con tarjeta bancaria o ahorra con la Tarjeta Cliente.
        </p>
        <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Button asChild size="lg" data-testid="prices-como-llegar-btn"
            className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-8 text-base h-12 w-full sm:w-auto">
            <a href="#ubicacion"><MapPin className="h-5 w-5 mr-2" /> Cómo llegar</a>
          </Button>
          <Button asChild size="lg" variant="outline" data-testid="prices-reservar-btn"
            className="rounded-full px-8 text-base h-12 w-full sm:w-auto border-slate-600 bg-transparent text-white hover:bg-slate-800 hover:text-white">
            <Link to="/reservar"><Truck className="h-5 w-5 mr-2" /> Prefiero recogida a domicilio</Link>
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-8 sm:mb-12" data-testid="instore-prices-grid">
        {MACHINES.map((m) => <MachineCard key={m.name} machine={m} />)}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-6">
        <ClientCardBanner />
        <VendingBlock />
      </div>
    </div>
  </section>
);
